export default __webpack_public_path__ + "static/media/camera.1ebea0ff.svg";